<template>
    <div class="member-profile">
        <div class="member-profile-head">
            <div class="member-profile-title">
                {{ $t('Client.title.member_funnel') }}
            </div>
            <el-select
                v-model="form.storeId"
                :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="form.period" :placeholder="$t('Client.latelyweek')">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" @click="fetchData"> {{ $t('Common.search_cha') }} </el-button>
            <div class="profile-head-chart flex items-center justify-between">
                <div class="profile-head-chart-item">
                    <div class="head-chart-title flex itmes-center">
                        <div>{{ $t('Client.title.membership') }}</div>
                        <div v-if="form.period !== 1" class="head-chart-title-tip">{{ $t('Client.three') }}：{{ formData.onlineCount }}{{ $t('Client.people') }}</div>
                    </div>
                    <div class="head-chart-conten flex">
                        <div style="width: 80%;" class="chart-member-funnel flex items-center justify-center">
                            <div class="stat_trapezoid traps_3">
                                <div class="traps trap_w_1">
                                    <span class="trap_num">
                                        <b>{{ formData.newCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalEnrollPercent }}
                                    </span>
                                </div>
                                <div class="traps trap_w_2">
                                    <span class="trap_num">
                                        <b>{{ formData.enrollCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalEnrollPercent }}
                                    </span>
                                </div>
                                <div class="traps trap_w_3">
                                    <span class="trap_num">
                                        <b>{{ formData.renewCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalRenewPercent }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="member-chart-right text-center">
                            <div>{{ $t('Client.Add.add_client') }}</div>
                            <span class="chart-member-green">
                                <i>{{ formData.totalEnrollPercent }}</i>
                            </span>
                            <div>{{ $t('Client.transact_club') }}</div>
                            <span class="chart-member-purple">
                                <i>{{ formData.renewPercent }}</i>
                            </span>
                            <div>{{ $t('Client.continuation_again') }}</div>
                        </div>
                    </div>
                    <div class="head-chart-foot">
                        {{ $t('Client.indent') }}：{{ this.formData.totalMshpOrder }} {{ $t('Client.order_amount') }}：{{ this.formData.totalMshpAmount }}
                    </div>
                </div>
                <div class="profile-head-chart-item">
                    <div class="head-chart-title flex itmes-center">
                        <div>{{ $t('Client.title.private_funnel') }}</div>
                        <div v-if="form.period !== 1" class="head-chart-title-tip">{{ $t('Client.three') }}：{{ formData.onlineCount }}{{ $t('Client.people') }}</div>
                    </div>
                    <div class="head-chart-conten flex">
                        <div
                            style="width: 80%"
                            class="chart-member-funnel flex items-center justify-center">
                            <div class="stat_trapezoid traps_4">
                                <div class="traps trap_w_4">
                                    <span class="trap_num">
                                        <b>{{ formData.newCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>100%
                                    </span>
                                </div>
                                <div class="traps trap_w_5">
                                    <span class="trap_num">
                                        <b>{{ formData.enrollCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalEnrollPercent }}
                                    </span>
                                </div>
                                <div class="traps trap_w_6">
                                    <span class="trap_num">
                                        <b>{{ formData.purchaseCoachCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalPurchaseCoachPercent }}
                                    </span>
                                </div>
                                <div class="traps trap_w_7">
                                    <span class="trap_num">
                                        <b>{{ formData.repurchaseCoachCount || 0 }}{{ $t('Client.people') }}</b>
                                        <br>{{ formData.totalRepurchaseCoachPercent }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="member-chart-right text-center">
                            <div>{{ $t('Client.Add.add_client') }}</div>
                            <span class="chart-member-green2">
                                <i>{{ formData.totalEnrollPercent }}</i>
                            </span>
                            <div>{{ $t('Client.transact_club') }}</div>
                            <span class="chart-member-green3">
                                <i>{{ formData.purchaseCoachPercent }}</i>
                            </span>
                            <div>{{ $t('Client.buyprivate') }}</div>
                            <span class="chart-member-orange">
                                <i>{{ formData.repurchaseCoachPercent }}</i>
                            </span>
                            <div>{{ $t('Client.rebuyprivate') }}</div>
                        </div>
                    </div>
                    <div class="head-chart-foot">
                        {{ $t('Client.indent') }}：{{ formData.totalCoachOrder }} {{ $t('Client.order_amount') }}：{{ formData.totalCoachAmount }}
                    </div>
                </div>
            </div>
        </div>

        <div class="member-profile-foot">
            <div class="member-profile-title">
                {{ $t('Client.title.memberattr') }}
            </div>
            <el-select
                v-model="attrForm.storeId"
                :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="attrForm.period" :placeholder="$t('Client.latelyweek')">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" @click="fetchAttr"> {{ $t('Common.search_cha') }} </el-button>
            <div class="profile-foot-chart flex items-center justify-between">
                <div class="profile-foot-chart-item">
                    <div class="foot-chart-item-title">{{ $t('Client.title.membershipcond') }}</div>
                    <div id="chart-member-cicle"></div>
                </div>
                <div class="profile-foot-chart-item">
                    <div class="foot-chart-item-title">{{ $t('Client.title.membershipsex') }}</div>
                    <div id="chart-gender-cicle"></div>
                </div>
                <div class="profile-foot-chart-item">
                    <div class="foot-chart-item-title">{{ $t('Client.title.distributeage') }}</div>
                    <div id="chart-age-cicle"></div>
                </div>
            </div>
        </div>

        <div class="profile-foot-chart flex items-center justify-between">
            <div class="profile-foot-chart-item">
                <div class="foot-chart-item-title">{{ $t('Client.title.buyprivprop') }}</div>
                <div id="chart-trainer-cicle"></div>
            </div>
            <div class="profile-foot-chart-item">
                <div class="foot-chart-item-title">{{ $t('Client.title.gainditch') }}</div>
                <div id="chart-avenues-cicle"></div>
            </div>
            <div class="profile-foot-chart-item">
                <div class="foot-chart-item-title">{{ $t('Client.title.cons_seniority') }}</div>
                <div id="chart-avenues-conste"></div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';
import {DatePicker, Radio, RadioButton, RadioGroup} from 'element-ui';

export default {
    name: 'member-profile',
    components: {
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            tabPosition: 'dailyAdd',
            stores: [],
            form: {
                storeId: '',
                period: 1,
            },
            attrForm: {
                storeId: '',
                period: 1,
            },
            formData: {},
            attrData: {},
            options: [
                {
                    value: 1,
                    label: this.$t('Client.latelyweek'),
                }, {
                    value: 2,
                    label: this.$t('Client.latelyonemonth'),
                }, {
                    value: 3,
                    label: this.$t('Client.latelythrmonth'),
                }, {
                    value: 4,
                    label: this.$t('Client.latelysixmonth'),
                },
            ],
        };
    },
    created() {
        this.fetchStore();
        this.fetchData();
        this.fetchAttr();
    },
    methods: {
        fetchStore() {
            this.stores = [
                {
                    id: '',
                    name: this.$t('Common.all_store2'),
                },
            ];
            API.get(`store/list`).then(res => {
                res.filter(el => this.stores.push(el));
            });
        },
        async fetchData() {
            await API.get('statistic/client/funnel', {
                params: this.form,
            }).then(res => {
                this.formData = res;
            });
        },
        async fetchAttr() {
            await API.get('statistic/client/attribute', {
                params: this.attrForm,
            }).then(res => {
                this.attrData = res;
            });
            this.$nextTick(() => {
                this.initMemberCicle();
                this.initGenderCicle();
                this.initAgeCicle();
                this.initTrainerCicle();
                this.initAvenuesCicle();
                this.initAvenuesConste();
            });
        },
        // 星座排行
        initAvenuesConste() {
            const chartL = document.getElementById('chart-avenues-conste');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            const option = {
                color: ['#0E8DF2'],
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'scatter',
                    },
                },
                legend: {
                    data: this.$t('Client.title.cons_seniority'),
                },
                grid: {
                    left: '2%',
                    bottom: '1%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'value',
                        show: false,
                    },
                ],
                yAxis: [
                    {
                        type: 'category',
                        axisTick: {show: false},
                        data: this.attrData.constellation.map(el => el.constellationName),
                    },
                ],
                series: [
                    {
                        name: this.$t('Client.title.cons_seniority'),
                        type: 'bar',
                        barWidth: 16,
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                position: 'right',
                            },
                        },
                        data: this.attrData.constellation.map(el => el.count),
                    },
                ],
            };
            addChart.setOption(option);
        },
        // 获取渠道
        initAvenuesCicle() {
            const chartL = document.getElementById('chart-avenues-cicle');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            const option = {
                color: ['#0E8DF2'],
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'scatter',
                    },
                },
                legend: {
                    data: this.$t('Client.Add.get_attributes'),
                },
                grid: {
                    left: '2%',
                    bottom: '1%',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'value',
                        show: false,
                    },
                ],
                yAxis: [
                    {
                        type: 'category',
                        axisTick: {show: false},
                        data: this.attrData.channel.map(el => el.channelName),
                    },
                ],
                series: [
                    {
                        name: this.$t('Client.Add.get_attributes'),
                        type: 'bar',
                        barWidth: 16,
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                position: 'right',
                            },
                        },
                        data: this.attrData.channel.map(el => el.count),
                    },
                ],
            };
            addChart.setOption(option);
        },
        // 购买私教比例
        initTrainerCicle() {
            const chartL = document.getElementById('chart-trainer-cicle');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            let privatelessArr = [
                this.$t('Client.data.Hresidue_priv_lesson'),
                this.$t('Client.data.Nresidue_priv_lesson'),
                this.$t('Client.data.dresidue_priv_lesson')
                ];
            const option = {
                color: ['#0E8DF2', '#0CC3AA', '#ccc'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    x: 'center',
                    // data: ['有剩余私教课', '无剩余私教课', '未购买私教课'],
                    data: privatelessArr,
                },
                series: [
                    {
                        name: this.$t('Client.title.buypersonprop'),
                        type: 'pie',
                        radius: ['60%', '70%'],
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'normal',
                                },
                            },
                        },
                        data: [
                            {value: this.attrData.privCoach.clientWithSurplusLesson, name: this.$t('Client.data.Hresidue_priv_lesson')},
                            {value: this.attrData.privCoach.clientWithNoLesson, name: this.$t('Client.data.Nresidue_priv_lesson')},
                            {value: this.attrData.privCoach.clientNotPurchaseLesson, name: this.$t('Client.data.dresidue_priv_lesson')},
                        ],
                    },
                ],
            };
            addChart.setOption(option);
        },
        // 分布年龄
        initAgeCicle() {
            const chartL = document.getElementById('chart-age-cicle');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            let aggArr = [
                this.$t('Client.data.under_eighteen'),
                this.$t('Client.data.eighteen_among_twentyfour'),
                this.$t('Client.data.twentyfive_among_thirty'),
                this.$t('Client.data.thirtyone_among_forty'),
                this.$t('Client.data.Countries_among_sixty'),
                this.$t('Client.data.above_sixty-first')
            ];
            const option = {
                color: ['#0E8DF2', '#0CC3AA'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '2%',
                    bottom: '1%',
                    containLabel: true,
                },
                legend: {
                    data:[this.$t('Common.male'), this.$t('Common.female')]
                },
                xAxis : [
                    {
                        type : 'value',
                        show: false,
                    },
                ],
                yAxis : [
                    {
                        type : 'category',
                        axisTick : {show: true},
                        // data : ['18岁以下', '18~24岁', '25~30岁', '31~40岁', '41~50岁', '51~60岁', '61岁以上']
                        data: aggArr,
                    }
                ],
                series : [
                    {
                        name:this.$t('Common.male'),
                        type:'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                position: 'right',
                            }
                        },
                        data: [
                            this.attrData.maleAge.under18,
                            this.attrData.maleAge.between18And24,
                            this.attrData.maleAge.between25And30,
                            this.attrData.maleAge.between31And40,
                            this.attrData.maleAge.between41And50,
                            this.attrData.maleAge.between51And60,
                            this.attrData.maleAge.above61,
                        ],
                    },
                    {
                        name: this.$t('Common.female'),
                        type:'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                position: 'right',
                            }
                        },
                        data: [
                            this.attrData.femaleAge.under18,
                            this.attrData.femaleAge.between18And24,
                            this.attrData.femaleAge.between25And30,
                            this.attrData.femaleAge.between31And40,
                            this.attrData.femaleAge.between41And50,
                            this.attrData.femaleAge.between51And60,
                            this.attrData.femaleAge.above61,
                        ]
                    }
                ]
            };
            addChart.setOption(option);
        },
        // 会籍性别
        initGenderCicle() {
            const chartL = document.getElementById('chart-gender-cicle');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            const option = {
                color: ['#0E8DF2', '#0CC3AA', '#ccc'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    x: 'center',
                    data: [this.$t('Common.male'), this.$t('Common.female'), this.$t('Sell.Pay.other')],
                },
                series: [
                    {
                        name: this.$t('Client.title.membershipsex'),
                        type: 'pie',
                        radius: ['60%', '70%'],
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'normal',
                                },
                            },
                        },
                        data: [
                            {
                                value:  this.attrData.gender.gentlemen,
                                name: this.$t('Common.male'),
                            }, {
                                value:  this.attrData.gender.ladies,
                                name: this.$t('Common.female'),
                            }, {
                                value: this.attrData.gender.unset,
                                name: this.$t('Sell.Pay.other'),
                            },
                        ],
                    },
                ],
            };
            addChart.setOption(option);
        },
        // 会籍情况
        initMemberCicle() {
            const chartL = document.getElementById('chart-member-cicle');
            chartL.style.height = '300px';
            const addChart = echarts.init(chartL);
            addChart.clear();
            let membershipArr = [
                this.$t('Client.data.valid_official_member'),
                this.$t('Client.data.past_official_member'),
                this.$t('Client.data.latent_member')
            ];
            const option = {
                color: ['#0E8DF2', '#0CC3AA', '#ccc'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                legend: {
                    x: 'center',
                    // data: ['有效正式会员', '过期正式会员', '潜在客户'],
                    data: membershipArr,
                },
                series: [
                    {
                        name: this.$t('Client.title.membershipcond'),
                        type: 'pie',
                        radius: ['60%', '70%'],
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'normal',
                                },
                            },
                        },
                        data: [
                            {
                                value: this.attrData.mshp.validFullClient,
                                name: this.$t('Client.data.valid_official_member'),
                            }, {
                                value: this.attrData.mshp.expiredFullClient,
                                name: this.$t('Client.data.past_official_member'),
                            }, {
                                value: this.attrData.mshp.potentialClient,
                                name: this.$t('Client.data.latent_member'),
                            },
                        ],
                    },
                ],
            };
            addChart.setOption(option);
        },
    },
};
</script>
<style lang="scss">
.member-profile-title {
    font-size: 16px;
    font-weight: bold;
    color: #212121;
    padding-bottom: 15px;
    margin: 20px 0;
    border-bottom: 1px solid #e8e8e8;
}
.member-profile-head,
.member-profile-foot {
    width: 100%;
    .el-select {
        margin-left: .5rem;
    }
    .el-button {
        margin-left: .5rem;
    }
}
.profile-head-chart {
    margin: 25px 0;
}
.profile-head-chart-item {
    overflow: auto;
    border: 1px solid #f0f0f0;
    width: 49.5%;
}
.head-chart-conten {
    height: 332px;
}
.head-chart-title {
    font-size: 16px;
    padding: 11px 15px;
    color: #3c3c3c;
    margin-bottom: 20px;
    font-weight: 400;
    border-bottom: 1px solid #f0f0f0;
}
.head-chart-title-tip {
    line-height: 20px;
    font-size: 12px;
    color: #05abef;
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid #f0f0f0;
}
.head-chart-foot {
    font-size: 14px;
    color: #3c3c3c;
    padding: 20px 0 20px;
    line-height: 1;
    margin: 20px 20px 0;
    border-top: 1px solid #f0f0f0;
}
.profile-foot-chart {
    width: 100%;
    margin-top: 25px;
}
.profile-foot-chart-item {
    overflow: auto;
    width: 100%;
    width: 32%;
    padding: 10px 0;
    border: 1px solid #f0f0f0;
}
.foot-chart-item-title {
    font-size: 16px;
    color: #3c3c3c;
    padding: 5px 15px 15px;
    line-height: 1;
    margin-bottom: 20px;
    font-weight: 400;
}
.member-chart-right {
    font-size: 12px;
    width: 20%;
    border-left: 1px solid #e6e6e6;
    div {
        margin: 20px 0;
    }
    span {
        display: block;
        position: relative;
        width: 70px;
        height: 40px;
        margin: 0 auto;
    }
    span::before {
        background: #73c589;
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 10px;
        width: 50px;
        height: 20px;
    }
    span::after {
        content: "";
        display: block;
        position: absolute;
        top: 20px;
        left: 0;
        width: 0;
        height: 0;
        border-top-width: 20px;
        border-top-style: solid;
        border-left: 35px solid transparent;
        border-right: 35px solid transparent;
        border-top-color: #73c589;
    }
    .chart-member-green {
        &::before {
            background: #73c589;
        }
        &::after {
            border-top-color: #73c589;
        }
    }
    .chart-member-green2 {
        &::before {
            background: #77d58e;
        }
        &::after {
            border-top-color: #77d58e;
        }
    }
    .chart-member-green3 {
        &::before {
            background: #b7d570;
        }
        &::after {
            border-top-color: #b7d570;
        }
    }
    .chart-member-purple {
        &::before {
            background: #688cfc;
        }
        &::after {
            border-top-color: #688cfc;
        }
    }
    .chart-member-orange {
        &::before {
            background: #fdb15d;
        }
        &::after {
            border-top-color: #fdb15d;
        }
    }
    i {
        display: block;
        width: 100%;
        position: absolute;
        top: 9px;
        color: #fff;
        font-size: 14px;
        line-height: 1;
        text-align: center;
        font-style: normal;
        z-index: 1;
        text-shadow: 0 0 5px rgba(0,0,0,.5);
    }
}
.chart-member-funnel {
    margin: 0 auto;
    .traps{
        border-top-width: 80px;
        border-top-style: solid;
        border-left: 35px solid transparent;
        border-right: 35px solid transparent;
        position: relative;
        margin: 0 auto;
        height: 0;
    }
    .trap_w_1 {
        width: 300px;
        border-top-color: #73c68a;
    }
    .trap_w_2 {
        width: 230px;
        border-top-color: #688cfc;
    }
    .trap_w_3 {
        width: 160px;
        border-top-color: #b6a4dd;
    }
    .traps_4 {
        .traps {
            border-top-width: 60px;
            border-top-style: solid;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
        }
        .trap_num {
            top: -43px;
        }
    }
    .trap_w_4 {
        width: 300px;
        border-top-color: #77d58e;
    }
    .trap_w_5 {
        width: 250px;
        border-top-color: #b7d570;
    }
    .trap_w_6 {
        width: 200px;
        border-top-color: #fdb15d;
    }
    .trap_w_7 {
        width: 150px;
        border-top-color: #fc7556;
    }
    .trap_num {
        top: -50px;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: center;
        color: #fff;
        font-size: 12px;
        line-height: 1;
        text-shadow: 0 0 5px rgba(0,0,0,.5);
        b {
            font-size: 14px;
            font-weight: 400;
        }
    }
}
</style>
